import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';
import env from 'src/shared/env';
import jwt_decode from 'jwt-decode';
// Components imports
import Button from 'src/components/common/Button';
import RadioButton from 'src/components/common/RadioButton';
import ECheckModalDesktop from '../ECheckModalDesktop';
import PayInvoiceRow from '../PayInvoiceRow';
import CheckPrintable from '../CheckPrintable';
import Input from 'src/components/common/Input';
import Alert from 'src/components/common/Alert';
import Modal from 'src/components/common/Modal';
// Models imports
import InvoiceModel from 'src/model/invoice.model';
import PaymentModel from 'src/model/invoice.model';
import BackArrow from '../../../../assets/backArrow';
import {
  IFiltersInvoice,
  IInvoiceCreditPayment
} from 'src/services/invoice/InvoiceService';
import CreditCardModel from 'src/model/creditCard.model';
import {
  ICreditCardError,
  ICreditCardSuccess
} from 'src/store/modules/creditcard/reducers';
import './PayRemainingPayment.scss';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import UserModel from 'src/model/user.model';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import VerticalTabs from '../PaymentChecks';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import paymenttheme from './paymenttheme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CloseIcon from 'src/assets/close';
import i18n from 'src/translation/i18n';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import AccountModel from 'src/model/account.model';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
class PayRemainingPayment extends React.Component<
  IPaymentModeDesktopProps,
  IPaymentModeDesktopState
> {
  // public arrowBack = () => {
  //     this.props.history.push('/invoices');
  //   };
  constructor(props: IPaymentModeDesktopProps) {
    super(props);

    this.state = {
      selectedMode: 'check',
      printCheck: false,
      showECheckModalDesktop: false,
      invoicesPaymentData: [],
      totalPayable: 0,
      isPaymentDisabled: false,
      creditSignature: '',
      invoices: [],
      value: 0,
      isActive: true,
      isEnable: false,
      isshow: false,
      debitamount: 0,
      showCancelPopup: false,
      isCreditCardEnabled: true
    };
  }
  public arrowBack = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state['navigateTo']
    ) {
      const navigateLink = this.props.location.state['navigateTo'];
      this.props.history.push('/invoices/' + navigateLink);
    } else {
      this.props.history.push('/invoices');
    }
  };
  private clickCredit = () => {
    this.props.history.push('/invoices/applyPayRemainingSuccess');
  };
  /* 
    userStatusCheck
   */
  private userStatusCheck = () => {
    const userStatus = {
      isLoggedIn: false,
      accountId: 'empty',
      sub: 'noAccount'
    };
    userStatus.isLoggedIn = 'accessToken' in localStorage;
    if (userStatus.isLoggedIn) {
      const token = jwt_decode(localStorage.getItem('accessToken'));
      userStatus.accountId = token.accountId;
      userStatus.sub = token.sub;
    }
    return userStatus;
  };
  private a11yProps(index: any) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`
    };
  }
  private handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({
      value: newValue
    });
    if (newValue === 0) {
      this.setSelectedPaymentMode('check');
    } else if (newValue === 1) {
      this.setSelectedPaymentMode('creditCard');
    } else if (newValue === 2) {
      this.setSelectedPaymentMode('echeck');
    }
  };
  private handleClick = () => {
    this.setState({
      isActive: true,
      isEnable: false,
      isshow: false
    });
  };
  private handleshow = () => {
    this.setState({
      isActive: false,
      isEnable: true,
      isshow: false
    });
  };

  private clickClose = () => {
    this.setState({ showCancelPopup: false });
  };
  private clickBack = () => {
    const state: any = this.props.location?.state;
    // this.props.history.push('/invoices')
    this.props.history.push({
      pathname: '/invoices/manualCredit',
      state: {
        continue: false,
        selectedDebit: state['backSelectedDebit']
      }
    });
  };
  private handleecheck = () => {
    this.setState({
      isActive: false,
      isEnable: false,
      isshow: true
    });
  };

  public componentDidMount = () => {
    if (typeof this.props.location.state === 'undefined') {
      this.props.history.push('/applyOriginal');
    }
    this.props.getUserDetails();
    this.prepareCheckData();
    this.setState({
      totalPayable: this.props.selectedInvoices.length,
      invoices: this.props.selectedInvoices
    });
    this.props.getSavedCards();
    this.props.getCreditCardStatus();
  };

  private prepareCheckData = () => {
    const preparedData: IInvoicePaymentData[] = [];
    let selectedData: any[] = [];
    const state: any = this.props.location?.state;

    if (
      state &&
      state.selectedDebitData &&
      state.selectedDebitData.length > 0
    ) {
      selectedData = state.selectedDebitData;
    } else {
      selectedData = this.props.selectedInvoices;
    }

    selectedData.forEach(invoice => {
      const paymentData: IInvoicePaymentData = {
        transactionId: invoice.transactionId,
        invoiceDate: invoice.invoiceDate, // invoice.dueDate,
        invoiceNumber: invoice.invoiceNumber,
        orderNumber: invoice.orderNumber,
        payment: invoice.paymentAmount,
        remaining: invoice.remainingAmount,
        total: invoice.totalAmount,
        notes: invoice.reasonText
      };
      preparedData.push(paymentData);
    });
    this.setState({ invoicesPaymentData: preparedData });
  };
  private handleCloseECheckModalDesktop = () => {
    this.setState({
      showECheckModalDesktop: false
    });
  };
  /* 
    getTotalDue
   */
  private getTotalDue = (): {
    total: number;
    totalDebit: number;
    totalCredit: number;
  } => {
    let total: number = 0;
    let totalCredit: number = 0;
    let totalDebit: number = 0;
    this.state.invoicesPaymentData.map(invoice => {
      total =
        Number(total.toFixed(2)) +
        Number(invoice.payment ? invoice.payment : 0);
      if (invoice.payment && invoice.payment > 0) {
        totalDebit = Number(totalDebit.toFixed(2)) + Number(invoice.payment);
      } else {
        totalCredit = Number(totalCredit.toFixed(2)) + Number(invoice.payment);
      }
    });
    return {
      total: Number(total.toFixed(2)),
      totalDebit: Number(totalDebit.toFixed(2)),
      totalCredit: Number(totalCredit.toFixed(2))
    };
  };

  /* 
    setSelectedPaymentMode
   */
  private setSelectedPaymentMode = (event: any) => {
    this.setState({
      selectedMode: event
    });
    this.props.clearAlert();
  };

  /* 
    getSelectedMode
   */
  private getSelectedMode = () => {
    const selections = {
      creditCard: false,
      check: false,
      echeck: false,
      credit: false
    };

    selections[this.state.selectedMode] = true;
    return selections;
  };

  /* 
    getInvoices
   */
  private getInvoices = (): {
    credits: JSX.Element[];
    invoices: JSX.Element[];
  } => {
    const invoices: JSX.Element[] = [];
    const credits: JSX.Element[] = [];

    this.state.invoices.map((invoice, index) => {
      if (invoice.remainingAmount < 0) {
        credits.push(
          <PayInvoiceRow
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      } else {
        invoices.push(
          <PayInvoiceRow
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      }
    });

    return { credits, invoices };
  };

  /* 
    handleCloseCheck
   */
  private handleCloseCheck = () => {
    if (this.state.printCheck === true) {
      this.setState({ printCheck: false });
    }
  };

  /* 
    handlePayment
   */
  private handlePayment = () => {
    switch (this.state.selectedMode) {
      case 'check':
        this.setState({ printCheck: true });
        this.props.clearAlert();
        break;
      case 'creditCard':
        this.handleCreditCardPayment();
        this.props.clearAlert();
        break;
      case 'echeck':
        this.setState({ showECheckModalDesktop: true });
        this.props.clearAlert();
        break;
      case 'credit':
        this.handleCreditPayment();
        this.props.clearAlert();
        break;
      default:
        break;
    }
  };

  private handlePayCancel = () => {
    this.setState({ showCancelPopup: true });
  };

  private handleCreditPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];

    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCredit(invoicesToPay, this.state.creditSignature);
  };

  private handleCreditCardPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];
    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCreditCard(
      invoicesToPay,
      this.props.selectedCreditCard.id,
      this.props
    );
  };

  /* 
    handleInvoicePaymentValues
   */
  private handleInvoicePaymentValues = (
    invoicePayment: IInvoicePaymentData
  ) => {
    const index = this.state.invoicesPaymentData.findIndex(
      invoice => invoice.invoiceNumber === invoicePayment.invoiceNumber
    );

    const paymentData: IInvoicePaymentData[] = [
      ...this.state.invoicesPaymentData
    ];
    if (index === -1) {
      paymentData.push(invoicePayment);
    } else {
      paymentData[index] = invoicePayment;
    }

    this.setState({ invoicesPaymentData: paymentData }, () => {
      if (
        !invoicePayment.payment ||
        (invoicePayment.remaining > 0 && !invoicePayment.notes)
      ) {
        this.setState({
          isPaymentDisabled: true
        });
      } else {
        let isDisabled = false;
        for (const invoice of this.state.invoicesPaymentData) {
          if (
            !invoice.payment ||
            (invoicePayment.remaining > 0 && !invoicePayment.notes)
          ) {
            isDisabled = true;
            break;
          }
        }

        this.setState({
          isPaymentDisabled: isDisabled
        });
      }
    });
  };

  private onCreditSignatureChange = (creditSignature: string) => {
    if (
      !creditSignature ||
      (creditSignature !== ' ' &&
        !startEndWithWhiteSpacesValidation(creditSignature))
    ) {
      this.setState({ creditSignature });
    }
  };

  private renderAlert() {
    const getMessage = () =>
      this.props.errorPayment.hasFailed
        ? this.props.errorPayment.message
        : this.props.successPayment.hasSucceed
        ? this.props.successPayment.message
        : this.props.creditCardError.hasFailed
        ? this.props.creditCardError.message
        : this.props.creditCardSuccess.message;

    return (this.props.errorPayment && this.props.errorPayment.hasFailed) ||
      (this.props.successPayment && this.props.successPayment.hasSucceed) ||
      (this.props.creditCardError && this.props.creditCardError.hasFailed) ||
      (this.props.creditCardSuccess &&
        this.props.creditCardSuccess.hasSucceed) ? (
      <div className="rp-payment-mode-desktop--alert">
        <Alert
          styleClass="paymentAlert"
          message={!this.props.creditCardError.hasFailed && getMessage()}
          icon={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'rpds-error'
              : 'rpds-check-circle'
          }
          handleCloseAlert={() => {
            return;
          }}
          type={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'error'
              : 'success'
          }
        >
          {this.props.creditCardError.hasFailed &&
            getMessage()
              .split('-')
              .map((msg: string, idx: number) => (
                <span className="alert-extra-area-message" key={idx}>
                  {msg}
                </span>
              ))}
        </Alert>
      </div>
    ) : null;
  }

  private renderCreditCardOptions = () => {
    const { t } = this.props;
    return this.props.savedCreditCards &&
      this.props.savedCreditCards.length > 0 ? (
      this.props.creditCardIsPending ? (
        <span className="rp-invoices--saved-cards warning">
          {t('payments.inProcessDoNotLeavePage')}
        </span>
      ) : (
        <div className="rp-invoices--saved-cards">
          {this.props.savedCreditCards.map(card => (
            <RadioButton
              key={card.id}
              name={`**** **** **** ${card.number}`}
              extraText={card.type}
              value={card.id}
              checked={
                card.id === this.props.selectedCreditCard.id ? true : false
              }
              className="rp-radio-button--saved-card"
              onChange={e => this.props.onSelectCreditCard(card)}
            />
          ))}
        </div>
      )
    ) : (
      <span className="rp-invoices--saved-cards">
        {t('common.noSavedCard')}{' '}
      </span>
    );
  };

  /* 
    renderPaymentMethod
   */
  private renderPaymentMethod() {
    const userStatus = this.userStatusCheck();
    if (this.state.printCheck) {
      return (
        <CheckPrintable
          invoices={this.state.invoicesPaymentData}
          closeWindow={() => {
            this.handleCloseCheck();
          }}
          userAccount={userStatus.accountId}
          user={this.props.userData}
        />
      );
    } else if (this.state.showECheckModalDesktop) {
      return (
        <ECheckModalDesktop
          onCloseModal={this.handleCloseECheckModalDesktop}
          invoices={this.state.invoicesPaymentData}
          userAccount={userStatus.accountId}
        />
      );
    } else {
      // TODO: Credit card component
      return <div />;
    }
  }

  private renderProceedPayment() {
    const state: any = this.props.location?.state;
    const { t } = this.props;
    const { total, totalDebit, totalCredit } = this.getTotalDue();
    return (
      <React.Fragment>
        {this.state.selectedMode === 'credit' && (
          <div className="rp-payment-mode-desktop--credit-signature">
            <Input
              label={t('common.paymentSignature')}
              value={this.state.creditSignature}
              onChange={this.onCreditSignatureChange}
              required={true}
            />
          </div>
        )}
        <div className="rp-payment-mode-desktop--pay-invoices">
          {/* {this.state.selectedMode === 'credit' && (
            <div className="payment-total">
              <p>{`Credit: ${LocaleFormating.formatCurrency(totalCredit)}`}</p>
              <p>{`Debit: ${LocaleFormating.formatCurrency(totalDebit)}`}</p>
            </div>
          )} */}
          {/* <span className="payment-total">
            {state
              ? (state['debitAmount'] - state['creditAmount']).toFixed(2)
              : ''}
          </span> */}
          {/* <Button
            buttonClass="primary-custom-button pay-invoices-button"
            label={t('invoices.payInvoiceWithCount', {
              count: this.state.totalPayable
            })}
            textTransform="uppercase"
            height="40px"
            width="168px"
            action={this.handlePayment}
            disabled={
              this.state.isPaymentDisabled ||
              (this.state.selectedMode === 'credit' &&
                !this.state.creditSignature) ||
              total < 0 ||
              (this.state.selectedMode !== 'credit' && total === 0) ||
              (this.props.successPayment &&
                this.props.successPayment.hasSucceed) ||
              (this.state.selectedMode === 'creditCard' &&
                (!this.props.selectedCreditCard ||
                  this.props.creditCardIsPending)) ||
              (this.props.creditCardSuccess &&
                this.props.creditCardSuccess.hasSucceed)
            }
          /> */}
        </div>
        {this.state.selectedMode === 'credit' && (
          <div className="rp-payment-mode-desktop--credit-items-offset">
            <span className="credits-text">
              {`${t('invoices.creditsItemsOffset')}`}
            </span>
          </div>
        )}
      </React.Fragment>
    );
  }

  public render() {
    const state: any = this.props.location?.state;
    const navigateTo =
      state && state['navigateTo'] ? state['navigateTo'] : 'open';
    const { t } = this.props;
    const methodSelection = this.getSelectedMode();
    const { invoices, credits } = this.getInvoices();
    const { total } = this.getTotalDue();

    const accountsArr: any = this.props.accounts;
    const userAccount: any = this.userStatusCheck();

    const index = accountsArr.findIndex(
      (account: { accountId: any }) =>
        account.accountId === userAccount.accountId
    );

    return (
      <MuiThemeProvider theme={paymenttheme}>
        <div className="rp-payment-mode-desktop payment-wrapper">
          {this.renderAlert()}
          <div className="d-flex payment-method-header">
            {navigateTo !== 'manualCredit' && (
              <img
                className="image-icon"
                onClick={this.arrowBack}
                src={BackArrow}
              />
            )}
            <div
              className="apply-heading"
              style={{
                marginLeft: navigateTo === 'manualCredit' ? '0px' : '20px'
              }}
            >
              {i18n.t('invoices.paymentMethod')}
            </div>
          </div>
          <div className="d-flex tabs-container">
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={this.state.value}
              onChange={this.handleChange}
              aria-label="Vertical tabs example"
            >
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                <Tab
                  label={i18n.t('invoices.paybyCheque')}
                  {...this.a11yProps(0)}
                  onClick={this.handleClick}
                />
              ) : (
                <Tab
                  label={i18n.t('invoices.paybyCheck')}
                  {...this.a11yProps(0)}
                  onClick={this.handleClick}
                />
              )}
              {this.props.creditCardStatus && (
                <Tab
                  label={i18n.t('invoices.paybyCreditCard')}
                  {...this.a11yProps(1)}
                  onClick={this.handleshow}
                />
              )}
              {env.REACT_APP_BASE_ENVIRONMENT === 'US' &&
                this.props.accounts[index]?.echeckStatus && (
                  <Tab
                    label={i18n.t('invoices.paybyEcheck')}
                    {...this.a11yProps(1)}
                    onClick={this.handleecheck}
                  />
                )}
            </Tabs>
            <div className="tabpanel">
              {this.state.isActive ? (
                <TabPanel value={0} index={0}>
                  <div className="payment-method">
                    <i className="rpds-i" />
                  </div>
                  {this.renderProceedPayment()}
                  {/* <div className="rp-payment-mode-desktop--invoices">
                    {credits.length > 0 && (
                      <React.Fragment>
                        <div className="invoices-header">
                          <span>{t('invoices.credit_plural')}</span>
                          <span>{t('invoices.totalAmount')}</span>
                          <span>{t('invoices.paymentAmount')}</span>
                          <span>{t('common.remaining')}</span>
                          <span />
                        </div>
                        {credits}
                      </React.Fragment>
                    )}
                    <div className="invoices-header">
                      <span>{t('invoices.invoice_plural')}</span>
                      <span>{t('invoices.totalAmount')}</span>
                      <span>{t('invoices.paymentAmount')}</span>
                      <span>{t('common.remaining')}</span>
                      <span>{t('invoices.reasonForRemainingBalance')}</span>
                    </div>
                    {invoices}
                  </div> */}
                  {this.renderPaymentMethod()}
                </TabPanel>
              ) : (
                ''
              )}
              {this.state.isEnable ? (
                <TabPanel value={1} index={1}>
                  {env.REACT_APP_INVOICE_CC_PAYMENT === 'true' && (
                    <div className="payment-method">
                      {/* <RadioButton
                  name={t('payment.byCreditCard')}
                  value="creditCard"
                  checked={methodSelection.creditCard}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                /> */}
                      {methodSelection.creditCard &&
                        this.renderCreditCardOptions()}
                    </div>
                  )}
                  {this.renderProceedPayment()}
                  {/* <div className="rp-payment-mode-desktop--invoices">
                    {credits.length > 0 && (
                      <React.Fragment>
                        <div className="invoices-header">
                          <span>{t('invoices.credit_plural')}</span>
                          <span>{t('invoices.totalAmount')}</span>
                          <span>{t('invoices.paymentAmount')}</span>
                          <span>{t('common.remaining')}</span>
                          <span />
                        </div>
                        {credits}
                      </React.Fragment>
                    )}
                    <div className="invoices-header">
                      <span>{t('invoices.invoice_plural')}</span>
                      <span>{t('invoices.totalAmount')}</span>
                      <span>{t('invoices.paymentAmount')}</span>
                      <span>{t('common.remaining')}</span>
                      <span>{t('invoices.reasonForRemainingBalance')}</span>
                    </div>
                    {invoices}
                  </div> */}
                  {this.renderPaymentMethod()}
                </TabPanel>
              ) : (
                ''
              )}

              {this.state.isshow ? (
                <TabPanel value={2} index={2}>
                  {env.REACT_APP_BASE_ENVIRONMENT === 'US' && (
                    <div className="payment-method">
                      {/* <RadioButton
                  name={t('payment.byEcheck')}
                  value="echeck"
                  checked={methodSelection.echeck}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                /> */}
                      <div className="payment-title">
                        <span className="title">
                          {t('payment.secureExternal')}
                        </span>
                      </div>
                    </div>
                  )}
                  {this.renderProceedPayment()}
                  {/* <div className="rp-payment-mode-desktop--invoices">
                    {credits.length > 0 && (
                      <React.Fragment>
                        <div className="invoices-header">
                          <span>{t('invoices.credit_plural')}</span>
                          <span>{t('invoices.totalAmount')}</span>
                          <span>{t('invoices.paymentAmount')}</span>
                          <span>{t('common.remaining')}</span>
                          <span />
                        </div>
                        {credits}
                      </React.Fragment>
                    )}
                    <div className="invoices-header">
                      <span>{t('invoices.invoice_plural')}</span>
                      <span>{t('invoices.totalAmount')}</span>
                      <span>{t('invoices.paymentAmount')}</span>
                      <span>{t('common.remaining')}</span>
                      <span>{t('invoices.reasonForRemainingBalance')}</span>
                    </div>
                    {invoices}
                  </div> */}
                  {this.renderPaymentMethod()}
                </TabPanel>
              ) : (
                ''
              )}
            </div>
            <div className="payment-summary">
              <div className="summary-credits">
                <div className="summary1">{i18n.t('invoices.summary')}</div>
                {/* <div className="payment-amount">
                  <div className="credit">Credit</div>
                  <div>{state ? state['creditAmount'].toFixed(2) : ''}</div>
                </div> */}
              </div>
              <div className="payment-credits">
                {/* <div className="payment-amount">
                  <div className="calculated-pay">Calculated Payment</div>
                  <div>{state ? state['youPayAmount'] : ''}</div>
                </div> */}
                <div className="payment-amount">
                  <div className="you-pay">{i18n.t('invoices.youPay')}</div>
                  <div className="youpay-amt">
                    {state && state['debitAmount']
                      ? currencyFormatter(Number(state['debitAmount']))
                      : currencyFormatter(0)}
                  </div>
                </div>
                <div className="text-align-center btn-wrapper">
                  {/* <button className="ok-btn" onClick={this.clickCredit}>
                    Pay
                  </button> */}
                  <Button
                    buttonClass="primary-custom-button pay-cancel-btn pay-invoices-button"
                    label="Cancel"
                    textTransform="uppercase"
                    height="40px"
                    width="148px"
                    action={this.handlePayCancel}
                  />
                  <Button
                    buttonClass="primary-custom-button pay-invoices-button ok-btn"
                    label="Pay"
                    textTransform="uppercase"
                    height="42px"
                    width="148px"
                    action={this.handlePayment}
                    disabled={
                      this.state.isPaymentDisabled ||
                      (this.state.selectedMode === 'credit' &&
                        !this.state.creditSignature) ||
                      total < 0 ||
                      (this.state.selectedMode !== 'credit' && total === 0) ||
                      (this.props.successPayment &&
                        this.props.successPayment.hasSucceed) ||
                      (this.state.selectedMode === 'creditCard' &&
                        (!this.props.selectedCreditCard ||
                          this.props.creditCardIsPending)) ||
                      (this.props.creditCardSuccess &&
                        this.props.creditCardSuccess.hasSucceed)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showCancelPopup && (
          <Modal handleCloseModal={() => console.log('Modal closed')}>
            <div className="apply-original-modal">
              <div className="d-flex justify-space-bw">
                <div className="modal-label">
                  <b>{i18n.t('invoices.confirmation')}</b>
                </div>
                <div className="close-icon" onClick={this.clickClose}>
                  <img src={CloseIcon} />
                </div>
              </div>
              <div className="modal-content">{i18n.t('invoices.message7')}</div>

              <div className="text-align-center">
                <button className="ok-btn mr-20" onClick={this.clickBack}>
                  {i18n.t('common.yes')}
                </button>
                <button className="ok-btn" onClick={this.clickClose}>
                  {i18n.t('common.no')}
                </button>
              </div>
            </div>
          </Modal>
        )}
      </MuiThemeProvider>
    );
  }
}

export default PayRemainingPayment;

interface IPaymentModeDesktopProps extends RouteComponentProps {
  t: any;
  selectedInvoices: InvoiceModel[];
  oldestInvoicedata: PaymentModel[];
  userAccount: string;
  errorPayment: any;
  successPayment: any;
  filters: IFiltersInvoice;
  savedCreditCards: CreditCardModel[];
  selectedCreditCard: CreditCardModel;
  creditCardError: ICreditCardError;
  creditCardSuccess: ICreditCardSuccess;
  creditCardIsPending: boolean;
  userData: UserModel;
  children?: React.ReactNode;
  index: number;
  payInvoicesByCredit: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => void;
  clearAlert: () => void;
  getSavedCards: () => void;
  onSelectCreditCard(creditCard: CreditCardModel): void;
  payInvoicesByCreditCard: (
    invoicePayments: IInvoiceCreditPayment[],
    cardId: string,
    props: any
  ) => void;
  getUserDetails: () => void;
  total: number;
  accounts: AccountModel;
  creditCardStatus: boolean;
  getCreditCardStatus: () => void;
}

interface IPaymentModeDesktopState {
  selectedMode: 'check' | 'creditCard' | 'echeck' | 'credit';
  printCheck: boolean;
  showECheckModalDesktop: boolean;
  invoicesPaymentData: IInvoicePaymentData[];
  totalPayable: number;
  isPaymentDisabled: boolean;
  creditSignature: string;
  invoices: InvoiceModel[];
  value: any;
  isActive: boolean;
  isEnable: boolean;
  isshow: boolean;
  debitamount: 0;
  showCancelPopup: boolean;
  isCreditCardEnabled: boolean;
  // total: number;
}

export interface IInvoicePaymentData {
  transactionId: number;
  invoiceDate: string;
  invoiceNumber: number;
  orderNumber: number;
  payment: number;
  remaining: number;
  total: number;
  notes: string;
}
